<template>
  <div class="fk_detail">
    <el-dialog title="项目反馈详情" :visible.sync="commentflag" width="900px" @close='closeDig'>
      <p class="project-num">项目单号：{{feedBackInfo.projectId}}</p>
      <div style="margin-left:24px;">{{feedBackInfo.userName}}于{{feedBackInfo.createTime}}反馈</div>
      <!-- 反馈内容 -->
      <el-container class="fk_container" v-if="feedBackInfo.tips&&feedBackInfo.tips!=null">
        <el-aside class="left_aside" width="72px">
          <a><img src="../../../public/img/orderInfo2/li.png"></a><a>反馈内容</a>
        </el-aside>
          <el-main class="right_main" >
            <div class="con_tips">{{feedBackInfo.tips}}</div>
           <div class="voice" v-if='feedBackInfo.voicePaths!="" ' @click="musicmp3">
              {{feedBackInfo.times}}"
              <img v-if="gif == false" src="" class="yybf1" />
              <img v-if="gif == true" src="" class="yybf" />
            </div>
          </el-main>
      </el-container>
      <!-- 图片 -->
      <el-container class="fk_container" v-if="feedBackInfo.imgPathList&&feedBackInfo.imgPathList.length>0">
        <el-aside class="left_aside" width="72px">
          <a><img class="left_inside" src="../../../public/img/addProject/pic.png"></a><a>图片</a>
        </el-aside>
        <el-main class="right_main">
          <img v-for="(item,index) in feedBackInfo.imgPathList" preview="1" :key='index' :src="item|getBaseImgUrl" />
        </el-main>
      </el-container>
      <!-- 视频 -->
      <el-container class="fk_container" v-if="videoList&&videoList.length>0">
        <el-aside class="left_aside" width="72px">
          <a><img class="left_inside" src="../../../public/img/addProject/video.png"></a><a>视频</a>
        </el-aside>
        <el-main class="right_main" style="margin-right: 50px;" v-for="(item,index) in videoList" :key="index" >
           <video style="width:125px;height:125px;float:left;margin-right:1%;"  controls="controls">
              <source :src="item"  type="video/mp4">
           </video>
        </el-main>
      </el-container>
      <!-- 反馈建议 -->
      <el-container class="fk_container" v-if="feedBackInfo.handleType&&feedBackInfo.handleType!=''">
        <el-aside class="left_aside" width="72px">
          <a><img class="left_inside_e" src="../../../public/img/orderInfo2/handleAdv.png"></a><a>处理建议</a>
        </el-aside>
        <el-main class="right_main" >
            <div class="con_tips">
              {{feedBackInfo.handleTypeName}}{{feedBackInfo.handleAdvise==''? "" : ':'+feedBackInfo.handleAdvise}}
            </div>
        </el-main>
      </el-container>

      <!-- 查看的人 -->
      <el-container class="fk_container">
        <el-aside class="left_aside" width="72px">
          <a><img class="left_inside_e" src="../../../public/img/orderInfo2/eye.png"></a><a>查看的人</a>
        </el-aside>
        <el-main class="right_main">
          <p>{{feedBackInfo.projectFeedbackLogs.length}}人</p>
          <myAvatar :manArr="feedBackInfo.projectFeedbackLogs"></myAvatar>
        </el-main>
      </el-container>
      <!-- 关联工作内容 -->
      <el-container class="fk_container" v-if="feedBackInfo.projectContents&&feedBackInfo.projectContents.length>0">
        <el-aside class="left_aside" width="92px">
          <a><img src="../../../public/img/orderInfo2/li.png"></a><a>关联工作内容</a>
        </el-aside>
        <!-- 循环关联工作内容 -->
        <el-main class="right_main">
          <div class="man_list">
            <div class="info_text" style="width: 100%;" v-for="(item,index) in feedBackInfo.projectContents" :key="index">
              <div class="contents"  @click="openContentInfo(item)">
                <a style="margin-right: 20px;">{{index+1+'.'}}{{item.tips}}</a>
                <a class="pic"><img src="../../../public/img/addProject/pic.png">{{item.imgNum?item.imgNum:0}}(张)</a>
                <a class="vid"><img src="../../../public/img/addProject/video.png">{{item.videoNum?item.videoNum:0}}(个)</a>
              </div>
            </div>
          </div>
        </el-main>
      </el-container>
      <!-- 评论输入框 -->
      <div class="pl_form" v-if="feedBackInfo.flag!=1">
        <img src="../../../public/img/orderInfo2/brush.png">
        <textarea class="pl_input" @input="contentInput" type="textarea" ref="pl_input" confirm-type="send"
          adjust-position focus placeholder="可以输入评论哦！同时@可以及时提醒您要提醒的人" v-model="contentdata"></textarea>
        <el-button type="primary" @click="submitContent">评论</el-button>
      </div>
      <!-- 评论区域 -->
      <el-container class="fk_container">
        <el-aside class="left_aside" width="72px">
          <a><img src="../../../public/img/orderInfo2/brush.png"></a><a>评论</a>
        </el-aside>
        <el-main class="right_main mr_16h">
          <p>{{commentdata.length}}人</p>
          <div v-for="(item,commentId) in commentdata" :key="commentId">
            <div class="pl_item">
              <div class="pl_avt">
                <img :src="item.avatar?item.avatar:(item.headimgurl?item.headimgurl:'/img/default-avatar.png')" />
              </div>
              <div class="pl_right">
                <div>
                  <a class="pl_name">{{item.userName}}</a><a class="pl_time">{{item.createTime}}</a>
                </div>
                <div class="pl_msg_block">
                  <div class="pl_msg">{{item.content}}</div>
                  <a class="pl_fh" :data-id="item.userId" :data-commentId="item.parentId?item.parentId:item.commentId"
                    :data-name="item.userName" :data-type="item.userType" @click="reply" v-if="feedBackInfo.flag!=1">回复</a>
                </div>
              </div>
            </div>
            <!-- 回复 -->
            <div v-for="(children,index1) in item.children" :key="index1">
              <div class="pl_item" style="padding-left:60px;">
                <div class="pl_avt">
                  <img :src="children.avatar?children.avatar:(children.headimgurl?children.headimgurl:'/img/default-avatar.png')" />
                </div>
                <div class="pl_right">
                  <div>
                    <a class="pl_name">{{children.userName}}</a><a class="pl_time">{{children.createTime}}</a>
                  </div>
                  <div class="pl_msg_block">
                    <div class="pl_msg">{{children.content}}</div>
                    <a class="pl_fh" :data-id="children.userId" :data-commentId="children.parentId?children.parentId:children.commentId"
                      :data-name="children.userName" :data-type="children.userType" @click="reply" v-if="feedBackInfo.flag!=1">回复</a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </el-main>
      </el-container>

      <div class="block_view_l" v-if="feedBackInfo.flag==1">
        <div class=" title my_flex">
          <span>最终处理结果</span>
          <span>{{feedBackInfo.isCount!=1?'（不纳入客诉原因统计）':feedBackInfo.responsibleName}}</span>
        </div>
        <div class="detail" v-if="feedBackInfo.isCount==1">{{feedBackInfo.solveTips}}</div>
      </div>
      <!-- 按钮 -->
      <div class="dialog-footer" style="padding-right: 66px;text-align: right;" v-if="feedBackInfo.flag!=1&&feedBackInfo.isCloseAuth">
        <el-button class="blockbtn" type="primary" @click="showKsDlg">关闭问题</el-button>
      </div>
      <!-- <table_sys_dict> </table_sys_dict> -->

      <!-- 项目转态图标 -->
      <img class="fk_state" :src="feedBackInfo.flag==1?'/img/resolved.png':'/img/unresolved.png'" />
    </el-dialog>
    <!-- 客诉弹窗部分 -->
    <div class="ks_dlg">
      <el-dialog title="请选择客诉原因" width="600px" :show-close="showDlgCloseBtn" :visible.sync="ksfk">
        <el-checkbox v-model="kstj" label="纳入客诉原因统计" border></el-checkbox>
        <div  v-if="kstj" style="margin-bottom: 20px;">
          <div class="ks_rea">
            <div>
              <a>选择原因</a><a>（可多选）</a>
            </div>
            <div class="ks_reaList">
            <div v-for="(item,index) in reasonDict"  :key="index" class="ks_rea_item">
               <el-checkbox :class="item.checked?'on':''" :data-index="index" @change="selectReason(item)" border >{{item.name}}</el-checkbox>
            </div>
             </div>
          </div>
          <p>最终处理结果</p>
          <textarea class="ks_input" type="textarea" placeholder="请输入处理结果"  v-model="solveTips"></textarea>
        </div>
        <div class="dialog-footer" style="margin-top: 0;">
          <el-button class="border_gray" @click='ksfk=false'>取消</el-button>
          <el-button type="primary" @click="closeFeedbackBtn" class="block_blue">确认</el-button>
        </div>
      </el-dialog>
    </div>
    <!-- 请选择要@的人 -->
    <el-dialog :visible.sync="adduser" width="600px" title="请选择要@的人">
      <div style="margin-left:20px;" v-if="stakeholders.length>0||works.length>0">
        <div class="adduser" v-for="(item,index) in stakeholders" :key="index" >
          <div class="item_user" @click="selectPerson" :data-id="item.userId" :data-type="1" :data-index="index">
            <img :src="item.headimgurl?item.headimgurl:'../../../public/img/default-avatar.png'"/>
            <div class="item_userName">{{item.userName}}</div>
            <span class="item_deptName_span">项目相关人</span>
          </div>
        </div>
        <div class="adduser" v-for="(item,index) in works" :key="index">
          <div class="item_user" @click="selectPerson" :data-id="item.userId" :data-type="2" :data-index="index">
            <img :src="item.headimgurl?item.headimgurl:'../../../public/img/default-avatar.png'"/>
            <div class="item_userName">{{item.userName}}</div>
            <span class="item_deptName_span">师傅</span>
          </div>
        </div>
       </div>
    </el-dialog>
    <!-- 查看工作内容 -->
    <contentInfo ref="contentInfo"></contentInfo>
  </div>
</template>
<script>
  import {
    getComment2,
    insertComment2,
    getrecordinfo,
    getProjectAllUser,
    closeFeedback,
    getProjectInfo
  } from '@/api/admin/taskManagement'
  import {
    objKeySort
  } from '@/util/ajaxsign'
  import {
    dataday
  } from '@/util/dateT'
 import {
    getDictList
  } from '@/api/admin/dict'
  import {
    getImgLink
  } from '@/config/env'
   import {
    dateSplit
  } from '@/util/date';
  import '../../styles/comment2.scss'
  import myAvatar from "./components/myAvatar.vue";
  import contentInfo from "./contentInfo.vue";
  // import table_sys_dict from "../../views/admin/dict/index.vue";
  export default {
    components: {
      myAvatar,
      contentInfo
      // table_sys_dict
    },
    data() {
      return {
        commentflag: false,
        feedBackInfo: {}, //反馈信息对象
        gif: false, //语言gif图片是否展示
        serviceType: '',
        serviceId: '',
        infodata: undefined,
        radiorecord: '',
        commentdata: [], //评论信息
        state: '',
        ksfk: false, //客诉反馈
        showDlgCloseBtn: false, //是否显示弹窗关闭按钮
        kstj: false, //客诉统计
        warnUsers: [], //所有提醒人
        solvedUser: [],
        FeedbackLogs: [],
        contentdata: '', //评论数据
        isShowInputArae: false, //是否显示评论输入区
        stakeholders:[],//项目相关人
        works:[],//工人
        projectId:'',
        adduser:false,//@人员弹窗
        videoList:[],
        reasonDict:[],//客诉原因字典
        solveTips:'',   //客诉原因
        projectInfo:{}
       }
    },
    created() {
      this.getProInfo()
    },
    filters: {
      getBaseImgUrl: function(uri) {
        if (uri) {
          return getImgLink(uri);
        } else {
          return "";
        }
      },
    },
    methods: {
      //获取数据 设置展示
      commentstate(serviceId, serviceType, state,projectId) {
        this.serviceType = serviceType;
        this.serviceId = serviceId;
        this.state = state;
        this.projectId=projectId;
        this.commentflag = true;
        this.getcomment();
        this.getrecordinfo();
        // this.$previewRefresh();
        //加载字典
        this.getDictList();
      },
  
      //获取评论信息
      getcomment() {
        let that = this
        getComment2(objKeySort({
          serviceType: that.serviceType,
          serviceId: that.serviceId
        })).then(function(response){
          let resData = response.data.data;
          if (resData) {
            resData.forEach(data => {
              data.createTime = dataday(data.createTime);
              if(data.avatar&&data.avatar.indexOf('http')==-1){
                data.avatar=getImgLink(data.avatar)
              }
              if (data.children) {
                data.children.forEach(child => {
                  child.createTime = dataday(child.createTime)
                  if(child.avatar&&child.avatar.indexOf('http')==-1){
                    child.avatar=getImgLink(child.avatar)
                  }
                })
              }
            })
            that.commentdata = resData
          }
        })
      },

      //获取反馈信息
      getrecordinfo() {
        let that=this
        getrecordinfo(objKeySort({
          id: that.serviceId
        })).then(response => {
          that.feedBackInfo=[]
          that.feedBackInfo = response.data.data;
          that.feedBackInfo.createTime=dateSplit(response.data.data.createTime,5)
          let _projectFeedbackLogs=response.data.data.projectFeedbackLogs
					//去重
					let result = [];
					let FeedbackLogsdata = {};
          _projectFeedbackLogs.forEach(item=>{
            if(item.avatar&&item.avatar.indexOf('http')==-1){
              item.avatar=getImgLink(item.avatar)
            }
						if (!FeedbackLogsdata[item.userId]) {
							result.push(item);
							FeedbackLogsdata[item.userId] = true;
            }
            item.time=dateSplit(item.createTime,4)
          })
          response.data.data.projectFeedbackLogs=result
          that.feedBackInfo.imgPathList = (response.data.data.imgPaths!="") ? response.data.data.imgPaths.split(',') : [];
          that.feedBackInfo.videoPathList = (response.data.data.videoPaths!="") ? response.data.data.videoPaths.split(',') : [];
          that.feedBackInfo.voicePathList = (response.data.data.voicePaths!="") ? response.data.data.voicePaths.split(',') :[];
          //设置 关闭问题权限
          that.feedBackInfo.isCloseAuth=response.data.otherData.isCloseAuth;
          that.getVideoPath()
        })
      },

      getDictList(){
        let data={
          time:new Date().getTime(),
          code:'responsible'
        }
        getDictList(objKeySort(data)).then(response=>{
          this.reasonDict=response.data.data.responsible
          this.reasonDict.forEach(item=>{
            item.checked=false
          })
        })
      },

      //回复
      reply: function(e) {
        let that = this;
        if (e.currentTarget.dataset.id) {
          let replyInfo = {
            id: e.currentTarget.dataset.id,
            name: e.currentTarget.dataset.name,
            type: e.currentTarget.dataset.type,
            parentId: e.currentTarget.dataset.commentid
          }
          that.warnUsers.push(replyInfo);
          that.contentdata = '@' + replyInfo.name + ' '
          this.$refs.pl_input.focus()
        }
      },
      //发送评论
      submitContent: function() {
        var that = this
        var mdata = {
          serviceId: that.feedBackInfo.id,
          content: that.contentdata,
          userType: 2,
          remindUserInfo: JSON.stringify(that.warnUsers)
        }
        let replyInfo = undefined;
        that.warnUsers.forEach(user => {
          if (user.parentId) {
            replyInfo = user;
          }
        })
        if (replyInfo) {
          mdata.replyUserId = replyInfo.id;
          mdata.replyUserName = replyInfo.name;
          mdata.parentId = replyInfo.parentId;
        }

        //添加评论信息
        insertComment2(objKeySort(mdata)).then(obj => {
          let that = this
          if (obj.data.code == 200) {
            that.contentdata = '',
              that.warnUsers = [],
              that.replyInfo = {}
            //延迟时间 这里是1秒
            window.setTimeout(function(){that.getcomment()},1000);
          }
        })
      },

      //监听评论
      contentInput: function(e) {
        let that = this
        let value = e.data
        if(value=='@'){
          that.initAllUser()
          that.adduser=true
        }
      },

      //查看工作内容详情
      openContentInfo(content) {
        this.$refs.contentInfo.setData(content);
      },

     //初始化项目相关人和工人数据
      initAllUser:function(){
        let that = this;
        getProjectAllUser(objKeySort({projectId:that.projectId})).then(response => {
          if (response.data.data) {
             that.stakeholders=response.data.data.stakeholders,
             that.workers=response.data.data.workers
          }
        })
        },

      //选择
      selectPerson: function(e) {
        let that = this;
        let selectUser = {};
        if(e.currentTarget.dataset.type==1){
          let user = that.stakeholders[e.currentTarget.dataset.index];
          selectUser={
            id:user.userId,
            name:user.userName,
            type:1
          }
        }else{
          let user = that.workers[e.currentTarget.dataset.index];
          selectUser={
            id:user.id,
            name:user.name,
            type:1
          }
        }
        that.adduser=false
        that.contentdata = that.contentdata+selectUser.name+' ';
        this.$refs.pl_input.focus()
      },
      //播放语音
      musicmp3() {
        let that = this
        that.gif = true
        let palyVioce=new Audio(getImgLink(that.feedBackInfo.voicePathList))
        palyVioce.play();
        palyVioce.loop = false;
        palyVioce.addEventListener('ended', function () {
        //监听到播放结束后，在此处调用自己的接口
          that.gif = false
        }, false);
      },
      //图片路径处理
      getimgpath(data) {
        return getImgLink(data)
      },
      //视频路径处理
      getVideoPath(){
        let that = this
        let _videoList=that.feedBackInfo.videoPathList
        that.videoList=[]
        if(_videoList.length>0){
            let videoListItem={}
          _videoList.forEach(item=>{
            videoListItem=getImgLink(item)
            that.videoList.push(videoListItem)
        })
      }
    },
    //选择客诉原因
    selectReason(e){
       let that = this;
       that.reasonDict[e.num-1].checked = !that.reasonDict[e.num-1].checked;
    },
    closeFeedbackBtn(){
       let that = this;

      let responsibleCode = [];
      let responsibleName = [];
      that.reasonDict.forEach(dict=>{
        if(dict.checked){
          responsibleCode.push(dict.code);
          responsibleName.push(dict.name);
        }
      })

      // if(that.solveTips==""){
      //   that.$notify({
      //     title: '请输入处理结果内容',
      //     message: '温馨提示',
      //     type: 'warning'
      //   });
      //   return
      // }
      let mdata= {
        id:that.feedBackInfo.id,
        isCount:that.kstj?1:0,
        responsibleCode:responsibleCode.join(","),
        responsibleName:responsibleName.join(","),
        solveTips:that.solveTips
      }
      closeFeedback(objKeySort(mdata)).then(response=>{
        if(response.data.code==200){
					that.$notify({
						type: 'success',
						message: '提交成功'
					});
					that.getrecordinfo()
          that.$emit('func')
        }else{
         that.$notify({
           type: 'warning',
           message: response.data.msg
         });
        }
      })

      that.ksfk=false
    },
    showKsDlg() {
      let that=this
      that.ksfk = true
      //清除客诉数据
      that.solveTips='';
      that.kstj=false;
      that.reasonDict.forEach(item=>{
        item.checked=false
      })
    },
    closeDig() {
      let that=this
      console.log('反馈详情销毁')
      that.$emit('func')
    },

    }
  }
</script>
<style lang='scss' scoped>
.project-num{
    position: absolute;
    top: 25px;
    right: 80px;
    font-size: 12px;
    color: #303133;
}
</style>